module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "TOC"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ContentsPage"
  }, [_c('h1', {
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/GPRE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/PRE"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/ABR"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/INT"
    }
  }, [_vm._v("Introduction: what is this sermon? (5:1, 2)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/CH1"
    }
  }, [_vm._v("A Christian’s character: the beatitudes (5:3–12)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s influence: salt and light (5:13–16)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s righteousness: Christ, the Christian and the law (5:17–20)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s righteousness: avoiding anger and lust (5:21–30)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s righteousness: fidelity in marriage and honesty in speech (5:31–37)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s righteousness: non-retaliation and active love (5:38–48)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s religion: not hypocritical but real (6:1–6, 16–18)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s prayer: not mechanical but thoughtful (6:7–15)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s ambition: not material security but God’s rule (6:19–34)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s relationships: to his brothers and his Father (7:1–12)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s relationships: to false prophets (7:13–20)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christian’s commitment: the radical choice (7:21–27)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/CH13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: who is this preacher? (7:28, 29)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0